import { Select } from 'antd'
import React, { useEffect } from 'react'
import { getUserId } from '../helpers/auth'
import { toast } from 'react-toastify'
import { useListUsersQuery } from '../redux/Api/UserManagment/uMUsersApiSlice'

const UsersDropdown = ({
  onChange,
  onBlur,
  value,
  filters = {},
  insertion = false,
  title,
  className = ''
}) => {
  const { data, isLoading, error } = useListUsersQuery({
    page: '*',
    ordering: 'first_name,last_name',
    fields: 'id,first_name,last_name',
    ...filters
  })
  let options

  if (data) {
    options = data?.results?.map(x => {
      return {
        label: insertion ? x.last_name : `${x.first_name} ${x.last_name}`,
        value: x.id
      }
    })
    if (insertion) {
      options = [
        {
          label: 'Me',
          value: getUserId()
        },
        ...options
      ]
    }
  }
  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  return (
    <div className=' mb-3'>
      <label className=''>{title}</label>
      <br />
      <Select
        className={className}
        name='user'
        showSearch
        style={{
          width: '100%'
        }}
        optionFilterProp='label'
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? '')
            .toLowerCase()
            .localeCompare((optionB?.label ?? '').toLowerCase())
        }
        defaultValue={value}
        value={value}
        onChange={e => onChange('user', e)}
        onBlur={onBlur}
        loading={isLoading}
        options={options}
      />
    </div>
  )
}

export default UsersDropdown
